export default __webpack_public_path__ + "static/media/instagram.03930b5d.svg";